import mixpanel from 'mixpanel-browser';
import { IS_DEV, MIXPANEL_TOKEN } from './config';

/**
 * Initialize Mixpanel with Session Replay enabled only in production (IS_DEV = false)
 */
export const initMixpanel = (): void => {
  if (!IS_DEV) {
    try {
      console.log("init Replay");
      mixpanel.init(MIXPANEL_TOKEN, {
        // debug: true, // shows debug logs in console
        track_pageview: true,
        persistence: 'localStorage',
        // Session Replay configuration - only active when IS_DEV is false
        record_sessions_percent: 100, // Records 100% of all sessions, adjust as needed
        record_mask_all_text: false, // Show all text in replays (sensitive inputs are still always masked)
        record_mask_all_inputs: false, // Show input values; password/email/tel are always masked by Mixpanel regardless
        record_canvas: true, // Capture canvas elements
        record_allowed_iframe_origins: [
          'https://embed.smb.eiqshopping.com', // Allow recording the embedded SMB process iframe
        ],
      });
      // Explicitly start session recording to ensure it kicks off
      mixpanel.start_session_recording();
      console.log("Mixpanel initialized & session recording started");
    } catch (e) {
      console.error("Mixpanel init error:", e);
    }
  }
};

/**
 * Track an event in Mixpanel (only works in production)
 */
export const trackEvent = (eventName: string, properties?: Record<string, unknown>): void => {
  if (!IS_DEV) {
    mixpanel.track(eventName, properties);
  }
};

/**
 * Identify a user in Mixpanel (only works in production)
 */
export const identifyUser = (userId: string): void => {
  if (!IS_DEV) {
    mixpanel.identify(userId);
  }
};

/**
 * Manually start session recording (only works in production)
 */
export const startSessionRecording = (): void => {
  if (!IS_DEV) {
    mixpanel.start_session_recording();
  }
};

/**
 * Manually stop session recording (only works in production)
 */
export const stopSessionRecording = (): void => {
  if (!IS_DEV) {
    mixpanel.stop_session_recording();
  }
};

export default mixpanel;
